import {
  eventDispatcher,
  TOPICS,
  IAlertBanner,
  IActionBarUpdate,
} from "@origin-digital/event-dispatcher";

import { errorTracking } from "src/utils/tracking";

const showNotification = (
  type: IAlertBanner["payload"]["type"],
  message: string,
  heading?: string
) => {
  eventDispatcher.dispatch({
    payload: {
      heading,
      message,
      type,
    },
    topic: TOPICS.ALERT_BANNER_OPEN,
  });
};

export const showErrorNotification = (
  message: string,
  heading?: string
): void => {
  showNotification("error", message, heading);
  errorTracking(Error(message));
};

export const showSuccessNotification = (
  message: string,
  heading?: string
): void => {
  showNotification("success", message, heading);
};

export const hideNotification = (): void => {
  eventDispatcher.dispatch({
    payload: {},
    topic: TOPICS.ALERT_BANNER_CLOSE,
  });
};

export const updateActionBar = (
  mobileNavButton: IActionBarUpdate["payload"]["mobileNavButton"] = "close"
) => {
  eventDispatcher.dispatch({
    payload: {
      mobileNavButton,
    },
    topic: TOPICS.ACTION_BAR_UPDATE,
  });
};
